// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Next = require("../../reason/next/Next.bs.js");
let Alert = require("../common/Components/Alert.bs.js");
let React = require("react");
let Scalars = require("../../scalars/Scalars.bs.js");
let ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Formality = require("../../vendor/re-formality/Formality.bs.js");
let OptionExt = require("../common/OptionExt.bs.js");
let Breadcrumbs = require("../common/Components/Breadcrumbs.bs.js");
let Form__Input = require("../../uikit/reason/atoms/Form/Form__Input.bs.js");
let Form__Label = require("../../uikit/reason/atoms/Form/Form__Label.bs.js");
let FormalityUI = require("../common/Form/FormalityUI.bs.js");
let ReactRender = require("../../reason/utils/ReactRender.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let IsNewQueryParam = require("./IsNewQueryParam.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let Formality__ReactUpdate = require("../../vendor/re-formality/Formality__ReactUpdate.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let MarketingProfileSubpages = require("./MarketingProfileSubpages.bs.js");
let UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let TeamMarketingProfileSocialAccountsSettingsQuery_graphql = require("../../__generated__/TeamMarketingProfileSocialAccountsSettingsQuery_graphql.bs.js");
let TeamMarketingProfileSocialAccountsSettingsMutation_graphql = require("../../__generated__/TeamMarketingProfileSocialAccountsSettingsMutation_graphql.bs.js");
let TeamMarketingProfileSocialAccountsSettings_form_teamMarketingProfile_graphql = require("../../__generated__/TeamMarketingProfileSocialAccountsSettings_form_teamMarketingProfile_graphql.bs.js");

let validators = {
  yelp: undefined,
  tikTok: undefined,
  youTube: undefined,
  linkedIn: undefined,
  instagram: undefined,
  facebook: undefined,
  twitter: undefined
};

function initialFieldsStatuses(input) {
  return {
    yelp: "Pristine",
    tikTok: "Pristine",
    youTube: "Pristine",
    linkedIn: "Pristine",
    instagram: "Pristine",
    facebook: "Pristine",
    twitter: "Pristine"
  };
}

let initialFieldStatuses_xxx = initialFieldsStatuses;

function initialState(input) {
  return {
    input: input,
    fieldsStatuses: initialFieldsStatuses(input),
    collectionsStatuses: undefined,
    formStatus: "Editing",
    submissionStatus: "NeverSubmitted"
  };
}

function validateForm(input, param, param$1) {
  let match_0 = {
    TAG: "Ok",
    _0: input.yelp
  };
  let match_0$1 = {
    TAG: "Ok",
    _0: input.tikTok
  };
  let match_0$2 = {
    TAG: "Ok",
    _0: input.youTube
  };
  let match_0$3 = {
    TAG: "Ok",
    _0: input.linkedIn
  };
  let match_0$4 = {
    TAG: "Ok",
    _0: input.instagram
  };
  let match_0$5 = {
    TAG: "Ok",
    _0: input.facebook
  };
  let match_0$6 = {
    TAG: "Ok",
    _0: input.twitter
  };
  let yelpResult = match_0;
  let yelpResult$1;
  if (yelpResult.TAG === "Ok") {
    let tikTokResult = match_0$1;
    if (tikTokResult.TAG === "Ok") {
      let youTubeResult = match_0$2;
      if (youTubeResult.TAG === "Ok") {
        let linkedInResult = match_0$3;
        if (linkedInResult.TAG === "Ok") {
          let instagramResult = match_0$4;
          if (instagramResult.TAG === "Ok") {
            let facebookResult = match_0$5;
            if (facebookResult.TAG === "Ok") {
              let twitterResult = match_0$6;
              if (twitterResult.TAG === "Ok") {
                return {
                  TAG: "Valid",
                  output: {
                    twitter: twitterResult._0,
                    facebook: facebookResult._0,
                    instagram: instagramResult._0,
                    linkedIn: linkedInResult._0,
                    youTube: youTubeResult._0,
                    tikTok: tikTokResult._0,
                    yelp: yelpResult._0
                  },
                  fieldsStatuses: {
                    yelp: {
                      TAG: "Dirty",
                      _0: yelpResult,
                      _1: "Hidden"
                    },
                    tikTok: {
                      TAG: "Dirty",
                      _0: tikTokResult,
                      _1: "Hidden"
                    },
                    youTube: {
                      TAG: "Dirty",
                      _0: youTubeResult,
                      _1: "Hidden"
                    },
                    linkedIn: {
                      TAG: "Dirty",
                      _0: linkedInResult,
                      _1: "Hidden"
                    },
                    instagram: {
                      TAG: "Dirty",
                      _0: instagramResult,
                      _1: "Hidden"
                    },
                    facebook: {
                      TAG: "Dirty",
                      _0: facebookResult,
                      _1: "Hidden"
                    },
                    twitter: {
                      TAG: "Dirty",
                      _0: twitterResult,
                      _1: "Hidden"
                    }
                  },
                  collectionsStatuses: undefined
                };
              }
              yelpResult$1 = yelpResult;
            } else {
              yelpResult$1 = yelpResult;
            }
          } else {
            yelpResult$1 = yelpResult;
          }
        } else {
          yelpResult$1 = yelpResult;
        }
      } else {
        yelpResult$1 = yelpResult;
      }
    } else {
      yelpResult$1 = yelpResult;
    }
  } else {
    yelpResult$1 = yelpResult;
  }
  return {
    TAG: "Invalid",
    fieldsStatuses: {
      yelp: {
        TAG: "Dirty",
        _0: yelpResult$1,
        _1: "Hidden"
      },
      tikTok: {
        TAG: "Dirty",
        _0: match_0$1,
        _1: "Hidden"
      },
      youTube: {
        TAG: "Dirty",
        _0: match_0$2,
        _1: "Hidden"
      },
      linkedIn: {
        TAG: "Dirty",
        _0: match_0$3,
        _1: "Hidden"
      },
      instagram: {
        TAG: "Dirty",
        _0: match_0$4,
        _1: "Hidden"
      },
      facebook: {
        TAG: "Dirty",
        _0: match_0$5,
        _1: "Hidden"
      },
      twitter: {
        TAG: "Dirty",
        _0: match_0$6,
        _1: "Hidden"
      }
    },
    collectionsStatuses: undefined
  };
}

function useForm(initialInput, onSubmit) {
  let memoizedInitialState = React.useMemo(() => initialState(initialInput), [initialInput]);
  let match = Formality__ReactUpdate.useReducer(memoizedInitialState, (state, action) => {
    if (typeof action !== "object") {
      switch (action) {
        case "BlurYelpField" :
          let result = Formality.validateFieldOnBlurWithoutValidator(state.input.yelp, state.fieldsStatuses.yelp, status => {
            let init = state.fieldsStatuses;
            return {
              yelp: status,
              tikTok: init.tikTok,
              youTube: init.youTube,
              linkedIn: init.linkedIn,
              instagram: init.instagram,
              facebook: init.facebook,
              twitter: init.twitter
            };
          });
          if (result !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurTikTokField" :
          let result$1 = Formality.validateFieldOnBlurWithoutValidator(state.input.tikTok, state.fieldsStatuses.tikTok, status => {
            let init = state.fieldsStatuses;
            return {
              yelp: init.yelp,
              tikTok: status,
              youTube: init.youTube,
              linkedIn: init.linkedIn,
              instagram: init.instagram,
              facebook: init.facebook,
              twitter: init.twitter
            };
          });
          if (result$1 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$1,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurYouTubeField" :
          let result$2 = Formality.validateFieldOnBlurWithoutValidator(state.input.youTube, state.fieldsStatuses.youTube, status => {
            let init = state.fieldsStatuses;
            return {
              yelp: init.yelp,
              tikTok: init.tikTok,
              youTube: status,
              linkedIn: init.linkedIn,
              instagram: init.instagram,
              facebook: init.facebook,
              twitter: init.twitter
            };
          });
          if (result$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$2,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurLinkedInField" :
          let result$3 = Formality.validateFieldOnBlurWithoutValidator(state.input.linkedIn, state.fieldsStatuses.linkedIn, status => {
            let init = state.fieldsStatuses;
            return {
              yelp: init.yelp,
              tikTok: init.tikTok,
              youTube: init.youTube,
              linkedIn: status,
              instagram: init.instagram,
              facebook: init.facebook,
              twitter: init.twitter
            };
          });
          if (result$3 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$3,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurInstagramField" :
          let result$4 = Formality.validateFieldOnBlurWithoutValidator(state.input.instagram, state.fieldsStatuses.instagram, status => {
            let init = state.fieldsStatuses;
            return {
              yelp: init.yelp,
              tikTok: init.tikTok,
              youTube: init.youTube,
              linkedIn: init.linkedIn,
              instagram: status,
              facebook: init.facebook,
              twitter: init.twitter
            };
          });
          if (result$4 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$4,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurFacebookField" :
          let result$5 = Formality.validateFieldOnBlurWithoutValidator(state.input.facebook, state.fieldsStatuses.facebook, status => {
            let init = state.fieldsStatuses;
            return {
              yelp: init.yelp,
              tikTok: init.tikTok,
              youTube: init.youTube,
              linkedIn: init.linkedIn,
              instagram: init.instagram,
              facebook: status,
              twitter: init.twitter
            };
          });
          if (result$5 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$5,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurTwitterField" :
          let result$6 = Formality.validateFieldOnBlurWithoutValidator(state.input.twitter, state.fieldsStatuses.twitter, status => {
            let init = state.fieldsStatuses;
            return {
              yelp: init.yelp,
              tikTok: init.tikTok,
              youTube: init.youTube,
              linkedIn: init.linkedIn,
              instagram: init.instagram,
              facebook: init.facebook,
              twitter: status
            };
          });
          if (result$6 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$6,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "Submit" :
          let match = state.formStatus;
          if (typeof match === "object" && match.TAG === "Submitting") {
            return "NoUpdate";
          }
          let match$1 = validateForm(state.input, validators, state.fieldsStatuses);
          if (match$1.TAG !== "Valid") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: match$1.fieldsStatuses,
                collectionsStatuses: match$1.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: "AttemptedToSubmit"
              }
            };
          }
          let output = match$1.output;
          let error = state.formStatus;
          let tmp;
          tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : Primitive_option.some(error._0);
          return {
            TAG: "UpdateWithSideEffects",
            _0: {
              input: state.input,
              fieldsStatuses: match$1.fieldsStatuses,
              collectionsStatuses: match$1.collectionsStatuses,
              formStatus: {
                TAG: "Submitting",
                _0: tmp
              },
              submissionStatus: "AttemptedToSubmit"
            },
            _1: param => {
              let dispatch = param.dispatch;
              onSubmit(output, {
                notifyOnSuccess: input => dispatch({
                  TAG: "SetSubmittedStatus",
                  _0: input
                }),
                notifyOnFailure: error => dispatch({
                  TAG: "SetSubmissionFailedStatus",
                  _0: error
                }),
                reset: () => dispatch("Reset"),
                dismissSubmissionResult: () => dispatch("DismissSubmissionResult")
              });
            }
          };
          break;
        case "DismissSubmissionError" :
          let match$2 = state.formStatus;
          if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
            return "NoUpdate";
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "DismissSubmissionResult" :
          let match$3 = state.formStatus;
          if (typeof match$3 !== "object") {
            if (match$3 === "Editing") {
              return "NoUpdate";
            }
          } else if (match$3.TAG === "Submitting") {
            return "NoUpdate";
          }
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: "Editing",
              submissionStatus: state.submissionStatus
            }
          };
        case "Reset" :
          return {
            TAG: "Update",
            _0: initialState(initialInput)
          };
      }
    } else {
      switch (action.TAG) {
        case "UpdateYelpField" :
          let nextInput = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput.yelp, status => {
                let init = state.fieldsStatuses;
                return {
                  yelp: status,
                  tikTok: init.tikTok,
                  youTube: init.youTube,
                  linkedIn: init.linkedIn,
                  instagram: init.instagram,
                  facebook: init.facebook,
                  twitter: init.twitter
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateTikTokField" :
          let nextInput$1 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$1,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$1.tikTok, status => {
                let init = state.fieldsStatuses;
                return {
                  yelp: init.yelp,
                  tikTok: status,
                  youTube: init.youTube,
                  linkedIn: init.linkedIn,
                  instagram: init.instagram,
                  facebook: init.facebook,
                  twitter: init.twitter
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateYouTubeField" :
          let nextInput$2 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$2,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$2.youTube, status => {
                let init = state.fieldsStatuses;
                return {
                  yelp: init.yelp,
                  tikTok: init.tikTok,
                  youTube: status,
                  linkedIn: init.linkedIn,
                  instagram: init.instagram,
                  facebook: init.facebook,
                  twitter: init.twitter
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateLinkedInField" :
          let nextInput$3 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$3,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$3.linkedIn, status => {
                let init = state.fieldsStatuses;
                return {
                  yelp: init.yelp,
                  tikTok: init.tikTok,
                  youTube: init.youTube,
                  linkedIn: status,
                  instagram: init.instagram,
                  facebook: init.facebook,
                  twitter: init.twitter
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateInstagramField" :
          let nextInput$4 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$4,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$4.instagram, status => {
                let init = state.fieldsStatuses;
                return {
                  yelp: init.yelp,
                  tikTok: init.tikTok,
                  youTube: init.youTube,
                  linkedIn: init.linkedIn,
                  instagram: status,
                  facebook: init.facebook,
                  twitter: init.twitter
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateFacebookField" :
          let nextInput$5 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$5,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$5.facebook, status => {
                let init = state.fieldsStatuses;
                return {
                  yelp: init.yelp,
                  tikTok: init.tikTok,
                  youTube: init.youTube,
                  linkedIn: init.linkedIn,
                  instagram: init.instagram,
                  facebook: status,
                  twitter: init.twitter
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateTwitterField" :
          let nextInput$6 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$6,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$6.twitter, status => {
                let init = state.fieldsStatuses;
                return {
                  yelp: init.yelp,
                  tikTok: init.tikTok,
                  youTube: init.youTube,
                  linkedIn: init.linkedIn,
                  instagram: init.instagram,
                  facebook: init.facebook,
                  twitter: status
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "SetSubmittedStatus" :
          let input = action._0;
          if (input !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: input,
                fieldsStatuses: initialFieldsStatuses(input),
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: initialFieldsStatuses(state.input),
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "SetSubmissionFailedStatus" :
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: {
                TAG: "SubmissionFailed",
                _0: action._0
              },
              submissionStatus: state.submissionStatus
            }
          };
        case "MapSubmissionError" :
          let map = action._0;
          let error$1 = state.formStatus;
          if (typeof error$1 !== "object") {
            return "NoUpdate";
          }
          if (error$1.TAG !== "Submitting") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "SubmissionFailed",
                  _0: map(error$1._0)
                },
                submissionStatus: state.submissionStatus
              }
            };
          }
          let error$2 = error$1._0;
          if (error$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "Submitting",
                  _0: Primitive_option.some(map(Primitive_option.valFromOption(error$2)))
                },
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
      }
    }
  });
  let dispatch = match[1];
  let state = match[0];
  let match$1 = state.formStatus;
  let tmp;
  tmp = typeof match$1 !== "object" ? false : match$1.TAG === "Submitting";
  return {
    updateYelp: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateYelpField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateTikTok: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateTikTokField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateYouTube: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateYouTubeField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateLinkedIn: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateLinkedInField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateInstagram: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateInstagramField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateFacebook: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateFacebookField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateTwitter: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateTwitterField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    blurYelp: () => dispatch("BlurYelpField"),
    blurTikTok: () => dispatch("BlurTikTokField"),
    blurYouTube: () => dispatch("BlurYouTubeField"),
    blurLinkedIn: () => dispatch("BlurLinkedInField"),
    blurInstagram: () => dispatch("BlurInstagramField"),
    blurFacebook: () => dispatch("BlurFacebookField"),
    blurTwitter: () => dispatch("BlurTwitterField"),
    yelpResult: Formality.exposeFieldResult(state.fieldsStatuses.yelp),
    tikTokResult: Formality.exposeFieldResult(state.fieldsStatuses.tikTok),
    youTubeResult: Formality.exposeFieldResult(state.fieldsStatuses.youTube),
    linkedInResult: Formality.exposeFieldResult(state.fieldsStatuses.linkedIn),
    instagramResult: Formality.exposeFieldResult(state.fieldsStatuses.instagram),
    facebookResult: Formality.exposeFieldResult(state.fieldsStatuses.facebook),
    twitterResult: Formality.exposeFieldResult(state.fieldsStatuses.twitter),
    input: state.input,
    status: state.formStatus,
    dirty: () => {
      let match = state.fieldsStatuses;
      let tmp = match.yelp;
      if (typeof tmp === "object") {
        return true;
      }
      let tmp$1 = match.tikTok;
      if (typeof tmp$1 === "object") {
        return true;
      }
      let tmp$2 = match.youTube;
      if (typeof tmp$2 === "object") {
        return true;
      }
      let tmp$3 = match.linkedIn;
      if (typeof tmp$3 === "object") {
        return true;
      }
      let tmp$4 = match.instagram;
      if (typeof tmp$4 === "object") {
        return true;
      }
      let tmp$5 = match.facebook;
      if (typeof tmp$5 === "object") {
        return true;
      }
      let tmp$6 = match.twitter;
      return typeof tmp$6 === "object";
    },
    valid: () => {
      let match = validateForm(state.input, validators, state.fieldsStatuses);
      return match.TAG === "Valid";
    },
    submitting: tmp,
    submit: () => dispatch("Submit"),
    dismissSubmissionError: () => dispatch("DismissSubmissionError"),
    dismissSubmissionResult: () => dispatch("DismissSubmissionResult"),
    mapSubmissionError: map => dispatch({
      TAG: "MapSubmissionError",
      _0: map
    }),
    reset: () => dispatch("Reset")
  };
}

let Config = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialFieldStatuses_xxx: initialFieldStatuses_xxx,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

let convertFragment = TeamMarketingProfileSocialAccountsSettings_form_teamMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, TeamMarketingProfileSocialAccountsSettings_form_teamMarketingProfile_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(TeamMarketingProfileSocialAccountsSettings_form_teamMarketingProfile_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, TeamMarketingProfileSocialAccountsSettings_form_teamMarketingProfile_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(TeamMarketingProfileSocialAccountsSettings_form_teamMarketingProfile_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertVariables = TeamMarketingProfileSocialAccountsSettingsMutation_graphql.Internal.convertVariables;

let convertResponse = TeamMarketingProfileSocialAccountsSettingsMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = TeamMarketingProfileSocialAccountsSettingsMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, TeamMarketingProfileSocialAccountsSettingsMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use$1 = RescriptRelay_Mutation.useMutation(convertVariables, TeamMarketingProfileSocialAccountsSettingsMutation_graphql.node, convertResponse, convertWrapRawResponse);

let Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$1
};

function initialInputFromFragment(fragment) {
  let match = fragment.socialAccounts;
  return {
    twitter: OptionExt.toString(match.twitter),
    facebook: OptionExt.toString(match.facebook),
    instagram: OptionExt.toString(match.instagram),
    linkedIn: OptionExt.toString(match.linkedIn),
    youTube: OptionExt.toString(match.youTube),
    tikTok: OptionExt.toString(match.tikTok),
    yelp: OptionExt.toString(match.yelp)
  };
}

function TeamMarketingProfileSocialAccountsSettings$Form$InputField(props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Form__Label.make, {
          labelText: props.labelText
        }),
        className: "pt-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Form__Input.make, {
            placeholderText: props.placeholder,
            onChange: props.onChange,
            onBlur: props.onBlur,
            status: FormalityUI.UIKitStatus.ofOptFieldResult(props.status),
            value: props.value
          }),
          Stdlib_Option.getOr(Stdlib_Option.map(props.helpText, text => JsxRuntime.jsx("div", {
            children: text,
            className: "text-base text-gray-500"
          })), null)
        ],
        className: "mt-2 sm:col-span-2 sm:mt-0 sm:max-w-xs space-y-3"
      })
    ],
    className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6"
  });
}

let InputField = {
  make: TeamMarketingProfileSocialAccountsSettings$Form$InputField
};

function TeamMarketingProfileSocialAccountsSettings$Form(props) {
  let marketingProfile = RescriptRelay_Fragment.useFragment(TeamMarketingProfileSocialAccountsSettings_form_teamMarketingProfile_graphql.node, convertFragment, props.marketingProfile);
  let match = use$1();
  let mutate = match[0];
  let match$1 = IsNewQueryParam.use();
  let isNew = match$1[0];
  let router = Next.useRouter();
  let subpages = MarketingProfileSubpages.useTeamProfilePages(undefined, undefined);
  let nextPage = Stdlib_Option.flatMap(Stdlib_Array.findIndexOpt(subpages, param => param.page === "SocialMedia"), i => subpages[i + 1 | 0]);
  let form = useForm(initialInputFromFragment(marketingProfile), (param, param$1) => {
    let notifyOnFailure = param$1.notifyOnFailure;
    let notifyOnSuccess = param$1.notifyOnSuccess;
    mutate({
      input: {
        socialAccounts: {
          facebook: OptionExt.ofString(param.facebook),
          instagram: OptionExt.ofString(param.instagram),
          linkedIn: OptionExt.ofString(param.linkedIn),
          tikTok: OptionExt.ofString(param.tikTok),
          twitter: OptionExt.ofString(param.twitter),
          yelp: OptionExt.ofString(param.yelp),
          youTube: OptionExt.ofString(param.youTube)
        }
      }
    }, undefined, undefined, undefined, (param, param$1) => {
      let result = param.updateTeamMarketingProfileSocialAccounts;
      if (result === undefined) {
        return notifyOnFailure();
      }
      if (result.__typename !== "TeamMarketingProfileSocialAccountsUpdated") {
        return notifyOnFailure();
      }
      notifyOnSuccess(undefined);
      if (isNew && nextPage !== undefined) {
        return Next.Router.push(nextPage.path + `?is_new=1`, undefined, undefined, router);
      }
    }, param => notifyOnFailure(), undefined);
  });
  let match$2 = form.status;
  let tmp;
  if (typeof match$2 !== "object") {
    if (match$2 === "Editing") {
      tmp = null;
    } else {
      let __x = !isNew;
      tmp = ReactRender.ifTrue(JsxRuntime.jsx(Alert.Success.make, {
        title: "Your account was updated"
      }), __x);
    }
  } else {
    tmp = match$2.TAG === "Submitting" ? null : JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Alert.$$Error.make, {
          title: "There was an error updating your account. Please try again"
        }),
        className: "mt-4"
      });
  }
  return JsxRuntime.jsx("form", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(TeamMarketingProfileSocialAccountsSettings$Form$InputField, {
              onChange: event => form.updateTwitter((input, value) => ({
                twitter: value,
                facebook: input.facebook,
                instagram: input.instagram,
                linkedIn: input.linkedIn,
                youTube: input.youTube,
                tikTok: input.tikTok,
                yelp: input.yelp
              }), event.target.value),
              onBlur: param => form.blurTwitter(),
              value: form.input.twitter,
              status: form.twitterResult,
              labelText: "Twitter",
              placeholder: "URL or username"
            }),
            JsxRuntime.jsx(TeamMarketingProfileSocialAccountsSettings$Form$InputField, {
              onChange: event => form.updateFacebook((input, value) => ({
                twitter: input.twitter,
                facebook: value,
                instagram: input.instagram,
                linkedIn: input.linkedIn,
                youTube: input.youTube,
                tikTok: input.tikTok,
                yelp: input.yelp
              }), event.target.value),
              onBlur: param => form.blurFacebook(),
              value: form.input.facebook,
              status: form.facebookResult,
              labelText: "Facebook",
              placeholder: "URL or username"
            }),
            JsxRuntime.jsx(TeamMarketingProfileSocialAccountsSettings$Form$InputField, {
              onChange: event => form.updateInstagram((input, value) => ({
                twitter: input.twitter,
                facebook: input.facebook,
                instagram: value,
                linkedIn: input.linkedIn,
                youTube: input.youTube,
                tikTok: input.tikTok,
                yelp: input.yelp
              }), event.target.value),
              onBlur: param => form.blurInstagram(),
              value: form.input.instagram,
              status: form.instagramResult,
              labelText: "Instagram",
              placeholder: "URL or username"
            }),
            JsxRuntime.jsx(TeamMarketingProfileSocialAccountsSettings$Form$InputField, {
              onChange: event => form.updateLinkedIn((input, value) => ({
                twitter: input.twitter,
                facebook: input.facebook,
                instagram: input.instagram,
                linkedIn: value,
                youTube: input.youTube,
                tikTok: input.tikTok,
                yelp: input.yelp
              }), event.target.value),
              onBlur: param => form.blurLinkedIn(),
              value: form.input.linkedIn,
              status: form.linkedInResult,
              labelText: "LinkedIn",
              placeholder: "URL"
            }),
            JsxRuntime.jsx(TeamMarketingProfileSocialAccountsSettings$Form$InputField, {
              onChange: event => form.updateYouTube((input, value) => ({
                twitter: input.twitter,
                facebook: input.facebook,
                instagram: input.instagram,
                linkedIn: input.linkedIn,
                youTube: value,
                tikTok: input.tikTok,
                yelp: input.yelp
              }), event.target.value),
              onBlur: param => form.blurYouTube(),
              value: form.input.youTube,
              status: form.youTubeResult,
              labelText: "YouTube",
              placeholder: "URL or username"
            }),
            JsxRuntime.jsx(TeamMarketingProfileSocialAccountsSettings$Form$InputField, {
              onChange: event => form.updateTikTok((input, value) => ({
                twitter: input.twitter,
                facebook: input.facebook,
                instagram: input.instagram,
                linkedIn: input.linkedIn,
                youTube: input.youTube,
                tikTok: value,
                yelp: input.yelp
              }), event.target.value),
              onBlur: param => form.blurTikTok(),
              value: form.input.tikTok,
              status: form.tikTokResult,
              labelText: "TikTok",
              placeholder: "URL or username"
            }),
            JsxRuntime.jsx(TeamMarketingProfileSocialAccountsSettings$Form$InputField, {
              onChange: event => form.updateYelp((input, value) => ({
                twitter: input.twitter,
                facebook: input.facebook,
                instagram: input.instagram,
                linkedIn: input.linkedIn,
                youTube: input.youTube,
                tikTok: input.tikTok,
                yelp: value
              }), event.target.value),
              onBlur: param => form.blurYelp(),
              value: form.input.yelp,
              status: form.yelpResult,
              labelText: "Yelp",
              placeholder: "URL or username"
            })
          ],
          className: "space-y-8 border-b border-zinc-200 pb-12 sm:space-y-0 sm:divide-y sm:divide-zinc-200 sm:pb-0"
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
              href: Scalars.URL.toString(marketingProfile.publicUrl),
              target: "_blank",
              children: "View Profile"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                  disabled: form.submitting,
                  children: isNew ? "Save and continue" : "Save changes"
                }),
                JsxRuntime.jsx("div", {
                  children: tmp,
                  role: "status"
                })
              ],
              className: "flex flex-col items-end gap-3"
            })
          ],
          className: "flex justify-between items-baseline"
        })
      ],
      className: "space-y-6"
    }),
    onSubmit: event => {
      event.preventDefault();
      form.submit();
    }
  });
}

let Form = {
  Config: Config,
  Fragment: Fragment,
  Mutation: Mutation,
  initialInputFromFragment: initialInputFromFragment,
  InputField: InputField,
  make: TeamMarketingProfileSocialAccountsSettings$Form
};

function TeamMarketingProfileSocialAccountsSettings$Header(props) {
  let displayName = MarketingProfileSubpages.Page.Team.useDisplayName();
  let breadcrumbs = [
    {
      name: "Team Marketing Profile",
      href: "/account/team_marketing_profile"
    },
    {
      name: displayName("SocialMedia"),
      href: MarketingProfileSubpages.Page.Team.path("SocialMedia")
    }
  ];
  return JsxRuntime.jsxs("header", {
    children: [
      JsxRuntime.jsx(Breadcrumbs.make, {
        pages: breadcrumbs
      }),
      JsxRuntime.jsx("h2", {
        children: displayName("SocialMedia"),
        className: "text-zinc-800 text-3xl font-medium"
      })
    ],
    className: "space-y-3 border-b pb-2"
  });
}

let Header = {
  make: TeamMarketingProfileSocialAccountsSettings$Header
};

let convertVariables$1 = TeamMarketingProfileSocialAccountsSettingsQuery_graphql.Internal.convertVariables;

let convertResponse$1 = TeamMarketingProfileSocialAccountsSettingsQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = TeamMarketingProfileSocialAccountsSettingsQuery_graphql.Internal.convertWrapRawResponse;

let use$2 = RescriptRelay_Query.useQuery(convertVariables$1, TeamMarketingProfileSocialAccountsSettingsQuery_graphql.node, convertResponse$1);

let useLoader = RescriptRelay_Query.useLoader(convertVariables$1, TeamMarketingProfileSocialAccountsSettingsQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(TeamMarketingProfileSocialAccountsSettingsQuery_graphql.node, convertResponse$1, prim => prim);

let fetch = RescriptRelay_Query.fetch_(TeamMarketingProfileSocialAccountsSettingsQuery_graphql.node, convertResponse$1, convertVariables$1);

let fetchPromised = RescriptRelay_Query.fetchPromised(TeamMarketingProfileSocialAccountsSettingsQuery_graphql.node, convertResponse$1, convertVariables$1);

let retain = RescriptRelay_Query.retain(TeamMarketingProfileSocialAccountsSettingsQuery_graphql.node, convertVariables$1);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  use: use$2,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function TeamMarketingProfileSocialAccountsSettings(props) {
  let match = use$2(undefined, undefined, undefined, undefined);
  let marketingProfile = match.currentAccountV5.marketingProfile;
  if (marketingProfile.__typename === "TeamMarketingProfile") {
    return JsxRuntime.jsx("div", {
      children: JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(TeamMarketingProfileSocialAccountsSettings$Header, {}),
          JsxRuntime.jsx(TeamMarketingProfileSocialAccountsSettings$Form, {
            marketingProfile: marketingProfile.fragmentRefs
          })
        ],
        className: "space-y-8 sm:space-y-0"
      }),
      className: "bg-white p-6 shadow-sm rounded space-y-8"
    });
  } else {
    return UnselectedUnionMemberError.raise(`Unselected union member: ` + marketingProfile._0);
  }
}

let make = TeamMarketingProfileSocialAccountsSettings;

exports.Form = Form;
exports.Header = Header;
exports.Query = Query;
exports.make = make;
/* commitMutation Not a pure module */
